export default {
    noticeBuer: true,
    setNoticeBuer: function (){
        this.noticeBuer = false;
    },
    i18n:false,
    setI18n:function (){
        this.i18n = !this.i18n;
    }
}


// WEBPACK FOOTER //
// ./src/global/home.js